export default "__VITE_ASSET__wSD1tWLr__"